export function initCollapsibleSection(scope) {
  const sections = (scope || document).querySelectorAll('.etp-collapsible-section');

  sections.forEach((section) => {
    const header = section.querySelector('.etp-collapsible-section__header');
    const content = section.querySelector('.etp-collapsible-section__content');

    if (!header || !content || header.dataset.etpCollapsibleReady) return;

    header.dataset.etpCollapsibleReady = 'true';

    const getTransition = () => parseInt(section.dataset.transition || '200', 10);

    const setOpenState = (open) => {
      section.classList.toggle('brx-open', open);
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    // Initial closed state is rendered server-side as hidden="until-found".
    // Guard against any stale markup that predates that change.
    if (!section.classList.contains('brx-open') && !content.hasAttribute('hidden')) {
      content.setAttribute('hidden', 'until-found');
      header.setAttribute('aria-expanded', 'false');
    }

    const openSection = () => {
      // Drop hidden="until-found" first so the content is laid out and measurable.
      content.removeAttribute('hidden');
      setOpenState(true);

      const duration = getTransition();
      content.style.height = '0';
      content.style.overflow = 'hidden';
      content.style.transition = `height ${duration}ms ease`;

      const targetHeight = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = targetHeight;
      });

      content.addEventListener('transitionend', () => {
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        content.style.removeProperty('transition');
      }, { once: true });
    };

    const closeSection = () => {
      const duration = getTransition();
      content.style.height = content.scrollHeight + 'px';
      content.style.overflow = 'hidden';
      content.style.transition = `height ${duration}ms ease`;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.height = '0';
        });
      });

      content.addEventListener('transitionend', () => {
        content.setAttribute('hidden', 'until-found');
        content.style.removeProperty('height');
        content.style.removeProperty('overflow');
        content.style.removeProperty('transition');
      }, { once: true });

      setOpenState(false);
    };

    header.addEventListener('click', () => {
      if (section.classList.contains('brx-open')) {
        closeSection();
      } else {
        openSection();
      }
    });

    // Find-in-page or a text-fragment link matched hidden content: the browser
    // has already removed the hidden attribute, so just sync the visual state.
    content.addEventListener('beforematch', () => {
      setOpenState(true);
    });
  });
}
